"use strict";

exports.__esModule = true;
exports.debounce = debounce;
exports.delay = delay;
exports.generateEventId = generateEventId;
exports.generateGUID = generateGUID;
exports.generateSpanId = generateSpanId;
exports.generateTraceId = generateTraceId;
exports.getType = getType;
exports.interceptFunction = interceptFunction;
exports.restoreFunction = restoreFunction;
exports.toRegFormat = toRegFormat;
exports.transStrToReg = transStrToReg;
var _is = require("./is");
// 插值前缀
var PRE_SUF_FIX = '__';
// 类型匹配正则
var TYPE_REG = /^\[object ([a-z]*)\]$/;

/**
 * 劫持函数
 */
function interceptFunction(target, name, callback) {
  var registeredMethod = target[name];
  target["" + PRE_SUF_FIX + name + PRE_SUF_FIX] = registeredMethod;
  target[name] = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    callback.apply(this, args);
    if ((0, _is.isFunction)(registeredMethod)) {
      return registeredMethod.apply(this, args);
    }
  };
}

/**
 * 还原函数
 */
function restoreFunction(target, name) {
  var key = "" + PRE_SUF_FIX + name + PRE_SUF_FIX;
  if (typeof target[key] == 'function') {
    target[name] = target[key];
    delete target[key];
  }
}

/**
 * @description: GUID v4
 * @return {String}
 */
function generateGUID() {
  var guid = '';
  try {
    if (crypto && crypto.randomUUID) {
      guid = crypto.randomUUID();
    } else if (crypto && crypto.getRandomValues) {
      var buf = new Uint8Array(16);
      crypto.getRandomValues(buf);
      buf[6] = buf[6] & 0x0f | 0x40; // version 4 UUID
      buf[8] = buf[8] & 0x3f | 0x80; // variant 10xxxxxx
      guid = buf.reduce(function (str, _byte) {
        return str + _byte.toString(16).padStart(2, '0');
      }, '').replace(/^(.{8})(.{4})(.{4})(.{4})(.{12})$/, '\$1-\$2-\$3-\$4-\$5');
    }
  } catch (e) {
    //
  }
  if (!guid) {
    guid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : r & 0x3 | 0x8;
      return v.toString(16);
    });
  }
  return guid;
}

/**
 * @description: 随机生成 traceId 或 sessionId
 * @return {String}
 */
function generateTraceId() {
  var traceId = generateGUID().replace(/-/g, '');
  // 适配OpenTracing 实现（long long转成16进制最高位不能为0）
  if (traceId[0] === '0') {
    traceId = '1' + traceId.substring(1);
  }
  if (traceId[16] === '0') {
    traceId = traceId.substring(0, 16) + '1' + traceId.substring(17);
  }
  return traceId;
}

/**
 * @description: 随机生成 spanId
 * @param len {number}
 * @param radix {number}
 * @return {String}
 */
function generateSpanId(len, radix) {
  if (len === void 0) {
    len = 16;
  }
  if (radix === void 0) {
    radix = 16;
  }
  var result = '';
  for (var i = 0; i < len; i++) {
    result += Math.floor(Math.random() * radix).toString(radix);
  }
  return result;
}

/**
 * @description: 随机生成 eventId
 * @param sessionId {string} sessionId
 * @return {String}
 */
function generateEventId(sessionId) {
  var spanId = generateSpanId();
  return "00-" + sessionId + "-" + spanId;
}

/**
 * @desc 函数防抖
 * @param func 回调函数
 * @param wait 延迟执行毫秒数
 */
function debounce(func, wait) {
  var timer;
  if (!(0, _is.isFunction)(func)) {
    return;
  }
  return function () {
    var context = this;
    var args = arguments;
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      func.apply(context, args);
    }, wait);
  };
}

/**
 * @desc 函数延迟执行
 * @param func 回调函数
 * @param wait 延迟执行毫秒数
 */
function delay(func, wait) {
  if (!(0, _is.isFunction)(func)) {
    return;
  }
  for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    args[_key2 - 2] = arguments[_key2];
  }
  return setTimeout.apply(void 0, [func, +wait || 0].concat(args));
}

/**
 * @desc 需要严格区分object和array
 * @param obj 任意对象
 */
function getType(obj) {
  var type = Object.prototype.toString.call(obj);
  type = type.toLowerCase() || '';
  var arr = type.match(TYPE_REG);
  return arr === null || arr === void 0 ? void 0 : arr[1];
}

/**
 * @desc 将字符串转换成正则表达式
 * @param str 任意字符串
 * 注意，这里只支持 /xxx/ 这种格式，不支持修饰符，例如 /xxx/ig
 */
function transStrToReg(str) {
  if (getType(str) !== 'string') return str;
  if (str.length > 2 && str[0] === '/' && str[str.length - 1] === '/') {
    return new RegExp(str.substr(1, str.length - 2));
  }
  return str;
}

/**
 * 
 * @param config 配置
 * @param keys 需要转换的字段
 */
function toRegFormat(config, keys) {
  if (getType(keys) === 'string') {
    keys = [keys];
  }
  for (var i = 0, len = keys.length; i < len; i++) {
    var paths = keys[i].split('.');
    var lastIndex = paths.length - 1;
    if (!config) break;
    var tmp = config;
    for (var j = 0, jlen = paths.length; j < jlen; j++) {
      if (paths[j] === '[]') {
        if (getType(tmp) === 'array') {
          var lastPath = paths.splice(j + 1);
          lastPath = lastPath.join('.');
          for (var x = 0, xlen = tmp.length; x < xlen; x++) {
            toRegFormat(tmp[x], lastPath);
          }
        }
        break;
      }
      // 最后一层了，需要往前一层才能修改对象
      if (lastIndex === j && getType(tmp[paths[j]]) === 'string') {
        tmp[paths[j]] = transStrToReg(tmp[paths[j]]);
        break;
      }
      tmp = tmp[paths[j]];
      if (!tmp) break;
    }
    if (!tmp || getType(tmp) !== 'array') continue;
    for (var _j = 0, _jlen = tmp.length; _j < _jlen; _j++) {
      tmp[_j] = transStrToReg(tmp[_j]);
    }
  }
}